module.exports = "/api/cdn/public/static-assets/images/c521018f372c38b0f90575a2c03df0ff.png";